import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector } from '@STORE/index';

import {
    previewChapterIntroductionTextModalSlice,
    PreviewChapterIntroductionTextModalState,
    PreviewChapterIntroductionTextModalDispatchParams,
} from '@REDUCERS';

function createPreviewChapterIntroductionTextModalHook() {
    return function usePreviewChapterIntroductionTextModal(equalityFn?: EqualityFn<PreviewChapterIntroductionTextModalState>) {
        const state = useAppSelector((store) => store.previewChapterIntroductionTextModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: PreviewChapterIntroductionTextModalDispatchParams) => dispatch(previewChapterIntroductionTextModalSlice.actions.open(params)),
            close: () => dispatch(previewChapterIntroductionTextModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createPreviewChapterIntroductionTextModalHook();
